import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Tag } from 'primeng/tag';
import { RolesAdminService } from '@/core/api/sicom-api/sistema/roles/roles-admin.service';
import { flattenCatalogo } from '@/core/permissions';
import { agruparRoles, ModuloGrupo } from '../roles-agrupamento.util';
import { diagnosticar, DiagnosticoResultado } from './permissoes-diagnostico.util';

@Component({
    selector: 'app-permissoes-diagnostico',
    standalone: true,
    imports: [Tag],
    templateUrl: './permissoes-diagnostico.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Diagnóstico das roles: confronta o catálogo de permissões com as roles cadastradas (órfãs/faltantes). */
export class PermissoesDiagnostico {
    private readonly rolesService = inject(RolesAdminService);

    protected readonly carregando = signal(true);
    protected readonly erro = signal(false);
    protected readonly resultado = signal<DiagnosticoResultado | null>(null);
    protected readonly grupos = signal<ModuloGrupo[]>([]);

    constructor() {
        this.carregar();
    }

    protected carregar(): void {
        this.carregando.set(true);
        this.erro.set(false);
        this.rolesService.listarRoles().subscribe({
            next: (roles) => {
                const res = diagnosticar(roles, flattenCatalogo());
                this.resultado.set(res);
                this.grupos.set(agruparRoles(res.inventario));
                this.carregando.set(false);
            },
            error: () => {
                this.erro.set(true);
                this.carregando.set(false);
            }
        });
    }

    protected ehOrfa(role: string): boolean {
        return this.resultado()?.orfas.has(role) ?? false;
    }
}
